<template>
	<main id="main" class="main">
		<section class="lists">
		<div class="inner">
			<div id="tablinks" class="tabs tablinks">
			<button
				@click="clickTablink(1, '料亭和露擠壓瓶')"
				:class="{ active: tab_id == 1 }"
				class="tablink Sheet1_Click"
			>
				料亭和露擠壓瓶
			</button>
			<button
				@click="clickTablink(2, '鮮美露')"
				:class="{ active: tab_id == 2 }"
				class="tablink Sheet2_Click"
			>
				鮮美露
			</button>
			<button
				@click="clickTablink(3, '源釀醬油')"
				:class="{ active: tab_id == 3 }"
				class="tablink Sheet3_Click"
			>
				源釀醬油
			</button>
			<button
				@click="clickTablink(4, '丸大豆本釀醬油')"
				:class="{ active: tab_id == 4 }"
				class="tablink Sheet4_Click"
			>
				丸大豆本釀醬油
			</button>
			</div>
			<div class="cats tabcontent">
			<a
				v-for="i in article_data"
				:key="i.link"
				class="item"
				:href="i.link"
				target="_blank"
				rel="noreferrer noopener"
			>
				<div class="img">
				<img :src="resolveArticleImage(i)" :alt="i.title" @error="setFallbackImage" />
				</div>
				<div class="description">
				<p>{{ i.title }}</p>
				</div>
			</a>
			</div>
		</div>
		</section>
		<section class="more-article">
		<button class="btn-more js-more-article Content_more_click" v-show="hasMoreArticles" @click="getArticlesFromApi()">看更多文章</button>
		</section>
	</main>
</template>

<script>
import axios from "axios";
import articleFallbackImage from "@/assets/banner.jpg";
import { ARTICLE_TABS, FALLBACK_ARTICLES_BY_TAG } from "@/data/fallbackArticles";

const DEFAULT_TAB = ARTICLE_TABS[0];
const CONTENT_SOURCE = process.env.VUE_APP_CONTENT_SOURCE || "fallback";

export default {
	name: "MainComponent",
	data() {
		return {
			api_url: "https://topic.events.pixnet.net/api/578/getTagArticles",
			article_data: [],
			article_max_page: 0,
			article_counter: 1,
			page_size: 9,
			randomTab: ARTICLE_TABS,
			tab_id: DEFAULT_TAB.id,
			tag_name: DEFAULT_TAB.name,
			fallback_image: articleFallbackImage,
		};
	},
	computed: {
		hasMoreArticles() {
			return this.article_counter <= this.article_max_page;
		},
		useLiveContent() {
			return CONTENT_SOURCE === "live";
		},
	},
	methods: {
		resolveArticleImage(article) {
			return article.image || this.fallback_image;
		},
		setFallbackImage(event) {
			if (event.target.dataset.fallbackApplied) {
				return;
			}

			event.target.dataset.fallbackApplied = "true";
			event.target.src = this.fallback_image;
		},
		addArticleCount() {
			this.article_counter = this.article_counter + 1;
		},
		resetArticleCount() {
			this.article_counter = 1;
		},
		setArticleMaxPage(pages) {
			this.article_max_page = pages;
		},
		getFallbackArticles(page = 1) {
			const articles = FALLBACK_ARTICLES_BY_TAG[this.tag_name] || [];
			const pageTotal = Math.max(1, Math.ceil(articles.length / this.page_size));
			const start = (page - 1) * this.page_size;

			return {
				articles: articles.slice(start, start + this.page_size),
				pageTotal,
			};
		},
		applyArticlePage({ articles, pageTotal }, reset = false) {
			this.setArticleMaxPage(pageTotal);
			this.article_data = reset ? articles : this.article_data.concat(articles);
			this.article_counter = pageTotal > 0 ? Math.min(this.article_counter + 1, pageTotal + 1) : 1;
		},
		async getArticlesFromApi() {
			if (!this.useLiveContent) {
				this.applyArticlePage(this.getFallbackArticles(this.article_counter));
				return;
			}

			try {
				const res = await axios.get(this.api_url, {
				params: {
					page_size: this.page_size,
					page: this.article_counter,
					tag_name: this.tag_name,
				},
				responseType: "json",
				timeout: 4000,
				});

				const pageTotal = res?.data?.data?.page_total || 0;
				const articles = res?.data?.data?.articles || [];

				if (!articles.length) {
					throw new Error("Empty live article response");
				}

				this.applyArticlePage({ articles, pageTotal });
			} catch {
				this.applyArticlePage(this.getFallbackArticles(this.article_counter));
			}
		},
		async toggleTagToGetArticle() {
			this.resetArticleCount();
			this.article_data = [];

			if (!this.useLiveContent) {
				this.applyArticlePage(this.getFallbackArticles(1), true);
				return;
			}

			try {
				const res = await axios.get(this.api_url, {
				params: {
					page_size: this.page_size,
					page: 1,
					tag_name: this.tag_name,
				},
				responseType: "json",
				timeout: 4000,
				});

				const pageTotal = res?.data?.data?.page_total || 0;
				const articles = res?.data?.data?.articles || [];

				if (!articles.length) {
					throw new Error("Empty live article response");
				}

				this.applyArticlePage({ articles, pageTotal }, true);
			} catch {
				this.applyArticlePage(this.getFallbackArticles(1), true);
			}
		},
		clickTablink(id, tag_name) {
			if (this.tab_id != id) {
				this.tab_id = id;
				this.tag_name = tag_name;
				this.toggleTagToGetArticle();
			}
		}
	},
	mounted() {
		this.getArticlesFromApi();
	},
};
</script>
